<template>

  <div>
    <MemberMobileNav @deposit="checkPromotions" @withdraw="moveCreditToWallet" />
    <div class="-main-footer-container js-replace-main-footer-container">
      <footer class="x-footer">
        <div class="container-fluid -footer-wrapper">
          <div class="-footer-bottom-wrapper">
            <div>
              <p class="mb-0" style="padding-top:20px;">
                Copyright © 2022 BM Hyper All Rights Reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import firebase from 'firebase/app'
import router from './../router'
import MemberMobileNav from '@/components/navigation/MemberMobileNav.vue'
export default {
  name: 'Footer',
  components: { MemberMobileNav },
  computed: {
    user () {
      return this.$store.state.user.user
    },
    lastbonus () {
      return this.$store.state.user.lastbonus
    }
  },
  methods: {
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    },
    async moveCreditToWallet () {
      this.$store.commit('user/SET_LOADING', true)
      const user = this.getUserId()
      this.$store.dispatch('user/moveCreditToWallet').finally(() => {
        this.$store.dispatch('user/getLastBonus', user).finally(() => {
          this.$store.commit('user/SET_LOADING', false)
          if (this.lastbonus.turncredit) {
            this.$store.commit('user/SET_ALERT_WITHDRAWALL', true)
          }
        }).catch(err => { console.error(err) })
      }).catch(err => { console.error(err) })
    },
    async checkPromotions () {
      this.$store.commit('user/SET_LOADING', true)
      this.$store.dispatch('user/checkPromotions').finally(() => { this.$store.commit('user/SET_LOADING', false) }).catch(err => { console.error(err) })
    }
  }
}
</script>
